import { Button, Card, Checkbox, Col, Flex, Pagination, PaginationProps, Row, Spin, theme } from 'antd';
import { FC } from 'react';
import { Toggles } from 'react-bootstrap-icons';

import { Domain } from '@/modules/Domains';

interface Props {
  domains: Pick<Domain, 'id' | 'name' | 'isConfigured'>[];
  pagination: PaginationProps;
  checkedDomains: string[];
  configureMultiDomainsLoading: boolean;
  handleCheckDomain: (id: string) => void;
  handleClearCheckedDomains: () => void;
  handleContinue: () => void;
}

export const DomainsMultiConfigurationModalView: FC<Props> = ({
  domains,
  pagination,
  checkedDomains,
  configureMultiDomainsLoading,
  handleCheckDomain,
  handleClearCheckedDomains,
  handleContinue
}) => {
  const { token: { colorError, colorSuccess } } = theme.useToken();

  return (
    <Row gutter={ [16, 16] }>
      <Col span={ 24 }>
        <Spin spinning={ configureMultiDomainsLoading }>
          <Row gutter={ [16, 16] }>
            {
              domains.map(({ id, name, isConfigured }) => (
                <Col span={ 6 } key={ id }>
                  <Card
                    size="small"
                    onClick={ () => (!configureMultiDomainsLoading && !isConfigured) && handleCheckDomain(id) }
                    style={
                      !isConfigured && !configureMultiDomainsLoading
                        ? { cursor: 'pointer' }
                        : {
                          cursor: 'not-allowed',
                          borderColor: 'var(--ant-button-border-color-disabled)',
                          color: 'var(--ant-color-text-disabled)',
                          background: 'var(--ant-color-bg-container-disabled)',
                          boxShadow: 'none',
                        }
                    }
                    hoverable={ !isConfigured }
                  >
                    <Flex align="center" gap={ 8 } justify="space-between">
                      <Flex align="center" gap={ 8 }>
                        {
                          isConfigured
                            ? <Toggles color={ colorSuccess }/>
                            : <Toggles color={ colorError }/>
                        }
                        <span>{ name }</span>
                      </Flex>

                      <Checkbox
                        checked={ !isConfigured && checkedDomains.includes(id) }
                        disabled={ isConfigured || configureMultiDomainsLoading }
                      />
                    </Flex>
                  </Card>
                </Col>
              ))
            }
          </Row>
        </Spin>
      </Col>

      <Col span={ 24 }>
        <Row gutter={ [16, 16] } justify={ 'space-between' } align="middle">
          <Col>
            <Flex justify="center">
              <Pagination
                showSizeChanger={ false }
                showQuickJumper
                showTotal={ (total, range) => `${ range[0] }-${ range[1] } з ${ total } елементів` }
                { ...pagination }
              />
            </Flex>
          </Col>

          <Col>
            <Flex align="center" gap={ 8 }>
              <Button
                disabled={ !checkedDomains.length }
                onClick={ handleClearCheckedDomains }
                danger
              >
                Очистити
              </Button>

              <Button
                onClick={ handleContinue }
                disabled={ !checkedDomains.length || configureMultiDomainsLoading }
              >
                <Flex align="center" gap={ 8 }>
                  <span>Сконфігурувати:</span>
                  <strong>{ checkedDomains.length }</strong>
                </Flex>
              </Button>
            </Flex>
          </Col>
        </Row>
      </Col>
    </Row>
  );
};
